var _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 10,
  height: 10,
  viewBox: "0 0 10 10"
}, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_5",
  "data-name": "Ellipse 5",
  cx: 5,
  cy: 5,
  r: 5,
  fill: "currentColor"
})));
export default __webpack_public_path__ + "static/media/circle-filled.a3113ae6.svg";
export { SvgComponent as ReactComponent };